const detailSwiper = new Swiper('.productdetail_swiper', {
    slidesPerView: 1,  
    centeredSlides: true,
    // spaceBetween: 16,
    loop: true,
    pagination: {                       
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
